import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var countFontSize = '12px';
var _ref = {
  name: "1fn0841",
  styles: "justify-content:flex-start;"
};
var _ref2 = {
  name: "1tyndxa",
  styles: "justify-content:center;"
};
var _ref3 = {
  name: "1bpvmlm",
  styles: "padding-right:12px;"
};
var _ref4 = {
  name: "mro3c9",
  styles: "padding-left:8px;padding-right:8px;"
};
var _ref5 = {
  name: "mro3c9",
  styles: "padding-left:8px;padding-right:8px;"
};
export default (function () {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref6$tabColour = _ref6.tabColour,
    tabColour = _ref6$tabColour === void 0 ? colors.neutral.heavy.selected : _ref6$tabColour,
    _ref6$tabInactiveColo = _ref6.tabInactiveColour,
    tabInactiveColour = _ref6$tabInactiveColo === void 0 ? colors.neutral.heavy.default : _ref6$tabInactiveColo,
    _ref6$tabBorderColour = _ref6.tabBorderColour,
    tabBorderColour = _ref6$tabBorderColour === void 0 ? colors.primary.base.default : _ref6$tabBorderColour,
    _ref6$hoverColour = _ref6.hoverColour,
    hoverColour = _ref6$hoverColour === void 0 ? colors.neutral.trim.hover : _ref6$hoverColour,
    _ref6$tabCountColour = _ref6.tabCountColour,
    tabCountColour = _ref6$tabCountColour === void 0 ? colors.neutral.medium.selected : _ref6$tabCountColour,
    alignment = _ref6.alignment,
    justification = _ref6.justification;
  var container = /*#__PURE__*/css("position:relative;display:flex;cursor:pointer;", alignment === 'left' && _ref, " ", alignment === 'centre' && _ref2, " color:", tabColour, ";padding-bottom:12px;padding-top:8px;height:44px;", justification === 'auto' && /*#__PURE__*/css("width:100%;", media('>=tablet'), "{", alignment === 'left' && _ref3, " ", alignment === 'centre' && _ref4, " width:auto;}"), " ", justification !== 'auto' && _ref5, " &.is-active,&:hover{transition:border-bottom 0.1s linear;}&:hover:not(&.is-active::before){border-bottom:4px solid ", hoverColour, ";}&.is-active::before{transform:scaleX(1);transition:0.4s ease-out;}&::before{position:absolute;bottom:0px;left:0;width:100%;height:0;transform:scaleX(0);transition:0.2s ease-out;border-bottom:4px solid ", tabBorderColour || tabColour, ";content:'';}&:not(.is-active){color:", tabInactiveColour, ";&:hover{border-bottom:4px solid ", hoverColour, ";}}");
  var item = /*#__PURE__*/css(designTokenFonts.overline, " display:flex;align-items:center;white-space:nowrap;height:18px;");
  var itemCount = /*#__PURE__*/css(designTokenFonts.mini, " font-size:", countFontSize, ";display:flex;align-items:center;margin-left:4px;max-width:32px;background-color:", hoverColour, ";color:", colors.neutral.subdued.default, ";text-align:center;padding-right:6px;padding-left:6px;border-radius:10px;height:18px;", media('>=tablet'), "{margin-left:8px;max-width:60px;}.is-active &{background-color:", tabCountColour, ";}");
  return {
    container,
    item,
    itemCount
  };
});